module.exports = __webpack_public_path__ + "assets/img/thelp.076aadb8.png";